<template>
    <div class="flex align-items-center justify-content-start ml-2 mt-2">
        <div class="w-7rem h-2rem  align-items-center justify-content-center pt-1">
            <img :src="localImageUrl" alt="Chesla logo" class="object-contain"  />
        </div>
        <div class="w-4rem h-2rem mt-1">
            <img :src="registered" alt="Right icon" class="w-3 h-4 object-contain" />
        </div>
    </div>

   <div class="flex ml-6 ">
        <Menubar :model="menuItems" class=" flex no-border-menubar pb-10 -mt-2 ml-2" />
   </div>
 </template>

<script>
  /* eslint-disable */
import router from '@/router';
import logoUrl from '@/assets/logo/chesla-logo.png'; 
import registeredLogo from '@/assets/logo/registered-logo.png';
export default {
  name: 'HeaderComponent',
  data() {
          return { 

                    localImageUrl: logoUrl,
                    registered: registeredLogo,
                    menuItems:[
                                  {
                                      label: 'О  компании',
                                      icon: 'pi pi-home',
                                      command: () => {
                                                router.push('/about');}
                                  },
                                  {
                                      label: 'Решения',
                                      icon: 'pi pi-server',
                                       command: () => {
                                                router.push('/solution');}
                                  },
                                  {
                                      label: 'Услуги',
                                      icon: 'pi pi-box',
                                      command: () => {
                                                router.push('/work');}
                                  },
                                  {
                                      label: 'Проекты',
                                      icon: 'pi pi-briefcase',
                                      command: () => {
                                                router.push('/project');}
                                  },
                                  {
                                      label: 'Отзывы',
                                      icon: 'pi pi-receipt',
                                      command: () => {
                                                router.push('/feedback');}
                                  },
                                  {
                                      label: 'Партнеры',
                                      icon: 'pi pi-id-card',
                                      command: () => {
                                                router.push('/partner');}
                                  },
                                  {
                                      label: 'Публикации',
                                      icon: 'pi pi-volume-down',
                                      command: () => {
                                                router.push('/publish');}
                                  },
                                  {
                                      label: 'Новости',
                                      icon: 'pi pi-globe',
                                      command: () => {
                                                router.push('/news');}
                                  },
                                  {
                                      label: 'Контакты',
                                      icon: 'pi pi-address-book',
                                      command: () => {
                                                router.push('/contact');}
                                  }
                                ]
                   }

        }
      }

</script>

<style>

    .logo {
        width: 150px;
        height : 50px;
       
    }

    .no-border-menubar {
        border-top-width:0px!important;
        border-bottom-width:0px!important;
        border-left-width:0px!important;
        border-right-width:0px!important;
        }

    .container {
        display: flex;
        flex-direction: column; 
        /* gap: 10px;  */
        }

    .item {
        width: 200px;
        height: 60px;
        }

</style>